import { mix } from './mix.es.js';
import { progress } from './progress.es.js';
function fillOffset(offset, remaining) {
  var min = offset[offset.length - 1];
  for (var i = 1; i <= remaining; i++) {
    var offsetProgress = progress(0, remaining, i);
    offset.push(mix(min, 1, offsetProgress));
  }
}
function defaultOffset(length) {
  var offset = [0];
  fillOffset(offset, length - 1);
  return offset;
}
export { defaultOffset, fillOffset };